import React, { useState, useEffect } from "react";

const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if cookies have been accepted
    const cookiesAccepted = localStorage.getItem("cookiesAccepted");
    if (!cookiesAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setIsVisible(false);
  };

  return isVisible ? (
    <div className="fixed bottom-0 hidden h-[120px] w-full bg-[#022928] px-4 py-3 text-white shadow-lg lg:flex lg:px-8 lg:py-4">
      <div className="mx-auto flex flex-col items-center justify-between lg:flex-row">
        <p className="text-sm lg:text-base text-center lg:text-left">
          This website uses{" "}
          <a
            href="https://separate-soup-1a5.notion.site/Cookie-Policy-145278ebc2bb8050a7b8f10dc0332b84?pvs=4"
            className="text-white underline hover:text-gray-200"
            target="_blank"
            rel="noopener noreferrer"
          >
            cookies
          </a>{" "}
          to deliver functionality and customize your experience. By using this
          website, you agree to our use of cookies. View our{" "}
          <a
            href="https://separate-soup-1a5.notion.site/Cookie-Policy-145278ebc2bb8050a7b8f10dc0332b84?pvs=4"
            className="text-white underline hover:text-gray-200"
            target="_blank"
            rel="noopener noreferrer"
          >
            cookie policy
          </a>{" "}
          for more details.
        </p>
        <button
          onClick={handleAccept}
          className="flex h-[40px] min-w-[146px] items-center justify-center rounded-full bg-[#FFF3ED] px-4 py-2 font-medium text-[#022928] transition-transform hover:scale-105 lg:ml-4 lg:mt-0"
        >
          <span className="text-sm">Accept All</span>
          <img
            src="/assets/icons/BlackArrow.svg"
            alt="arrow"
            className="ml-2 h-5 w-5"
          />
        </button>
      </div>
    </div>
  ) : null;
};

export default CookieBanner;
